// Tech ticker content — language-agnostic (product/tech names).
export const techStack = [
  ".NET 9",
  "React 18",
  "TypeScript",
  "Azure",
  "OpenAI",
  "SignalR",
  "CQRS",
  "PostgreSQL",
  "Docker",
  "YARP Gateway",
  "Clean Architecture",
  "EF Core",
  "Node.js",
  "React Native",
  "Redis",
  "CI/CD",
];

// The animated architecture.cs snippet for the About panel (colored tokens).
export const architectureCode = [
  { t: "public sealed class ", c: "#6c7fa8" },
  { t: "ProjectArchitecture\n", c: "#7ef0b0" },
  { t: "{\n  ", c: "#6c7fa8" },
  { t: "// clean layers, zero surprises\n  ", c: "#4a5b83" },
  { t: "Domain      ", c: "#9fb6e6" },
  { t: "→ business truth\n  ", c: "#6c7fa8" },
  { t: "Application ", c: "#9fb6e6" },
  { t: "→ use cases (CQRS)\n  ", c: "#6c7fa8" },
  { t: "Infra       ", c: "#9fb6e6" },
  { t: "→ EF Core, AI, mail\n  ", c: "#6c7fa8" },
  { t: "Api         ", c: "#9fb6e6" },
  { t: "→ thin, documented\n\n  ", c: "#6c7fa8" },
  { t: "scale", c: "#4d8dff" },
  { t: "() ", c: "#6c7fa8" },
  { t: "=> ", c: "#4d8dff" },
  { t: '"without a rewrite"', c: "#f0c674" },
  { t: ";\n}", c: "#6c7fa8" },
];
